import DashboardStatisticsTable from "../DashboardStatisticsTable";
import StatisticsChart from "../StatisticsChart";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { filterTable } from "../../store/actions/statisticsTable";
import RoundLoader from "../uiComponents/RoundLoader";
import NoResult from "../uiComponents/NoResult";

const DashboardStatisticsRightContent =  () => {

  const {initialTableContent, filteredTableContent} = useSelector((state) => state.statisticsTable);

  const { selectorsFieldData } = useSelector((state) => state.statisticsFilters)

  const dispatch = useDispatch()

  useEffect( () => {
    const filtersValueForTable = selectorsFieldData.reduce((currenValue, selectField) => {

      if (currenValue[selectField.type]) {
        currenValue[selectField.type] = [...currenValue[selectField.type], ...selectField.selectedItems]
      } else {
        currenValue[selectField.type] = [...selectField.selectedItems]
      }
      return currenValue
    }, {})

    if (filtersValueForTable) {
      dispatch(filterTable(filtersValueForTable))
    }

  } , [dispatch, selectorsFieldData])

  if (initialTableContent?.length === 0) {
    return <RoundLoader/>
  }

  if (filteredTableContent?.length === 0) {
    return <NoResult/>
  }

  return(
    <div className={"dashboard-statistics__content"}>
      <StatisticsChart/>
      <DashboardStatisticsTable/>
    </div>
  )
}


export default DashboardStatisticsRightContent;

